import { Component, OnInit } from '@angular/core';
import { CardElementsBaseComponent } from '../card-elements-base.component';

@Component({
  selector: 'cu-dynamic-card-validation',
  templateUrl: './card-validation.component.html',
  styleUrls: ['./card-validation.component.scss']
})
export class CardValidationComponent extends CardElementsBaseComponent implements OnInit {
  public ngOnInit(): void {}
}
